import React, { ReactElement } from 'react';
import { Link, NavLink } from 'react-router-dom';
import styled from 'styled-components';

import { ConditionalLinkProps } from './types';

const InternalLink = styled(Link)``;
const InternalNavLink = styled(NavLink)``;
const ExternalLink = styled('a')``;

const ConditionalLink = ({
  children,
  to,
  type,
  component = React.Fragment,
  target = '_self',
  activeStyle,
  replace,
  ...props
}: ConditionalLinkProps): ReactElement => {
  const ConditionComponent = component;

  if (type === 'external')
    return (
      <ExternalLink href={to} target={target} {...props}>
        {children}
      </ExternalLink>
    );
  if (type === 'internal')
    return (
      <InternalLink target={target} to={to} replace={replace} {...props}>
        {children}
      </InternalLink>
    );
  if (type === 'internalNav')
    return (
      <InternalNavLink target={target} to={to} replace={replace} activeStyle={activeStyle} {...props}>
        {children}
      </InternalNavLink>
    );

  return <ConditionComponent {...props}>{children}</ConditionComponent>;
};
export default ConditionalLink;
